import styled, { keyframes } from 'styled-components';

const loadingSpinAnimation = keyframes`
  100% { 
    transform: rotate(360deg);
  }
`;

const loadingFadeInAnimation = keyframes`
  from { 
    width: 0px;
  }
  to { 
    width: 18px;
  }
`;

const LoadingSpinner = styled.div`
  border-top: 3px solid rgba(255, 255, 255, 0.7);
  border-bottom: 3px solid transparent;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation:
    ${loadingSpinAnimation} 1s 0.05s infinite linear,
    ${loadingFadeInAnimation} 0.05s 1 linear;
`;

export default LoadingSpinner;
